import axios, { AxiosHeaderValue, AxiosInstance } from 'axios';
import { Env } from '../../config/env';
import { toCamelCase } from '@/utils/tools';
import { TMS_ADMIN_TOKEN } from '@/utils/constants';
import Cookies from 'js-cookie';
import Message from '@/components/message/message';

const handleTokenDisabled = () => {
  location.replace('/#/login');
  Cookies.remove(TMS_ADMIN_TOKEN);
};

export const api: AxiosInstance = axios.create({
  baseURL: Env.apiUrl,
  timeout: 1000 * 60 * 10, // 10min
});

export const setApiHeader = (header: { [key: string]: AxiosHeaderValue }) => {
  api.defaults.headers = {
    ...api.defaults.headers,
    ...header,
  };
};

/* 请求拦截器 */
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
/* 响应拦截器 */
api.interceptors.response.use(
  (response) => {
    if (response.data.Code && response.data.Code !== 20000) {
      Message.error(response.data.Message);
      return Promise.reject(new Error(response.data.Message));
    }
    return toCamelCase(response.data);
  },
  (error) => {
    // if (error.response && error.response.data) {
    //   return Promise.reject(new Error(error.response.data));
    // }
    if (error.response?.status === 401) {
      handleTokenDisabled();
    }
    Message.error(error);
    return Promise.reject(error);
  },
);
